<div
  class="aside-history-card"
  [style.height]="data.contentMessage ? '120px' : '80px'"
  [ngClass]="[
    'variant-' + (data.variant || 'default'),
    isSelected ? 'selected' : ''
  ]"
  [attr.aria-selected]="isSelected"
  (click)="handleSelectCard($event)"
>
  <div class="content">
    <div class="content__header">
      <h6 class="date">{{ data.date }}</h6>
      <span class="status-chip">{{
        getVariantLabel(data) + " " + data.numeration
      }}</span>
    </div>

    <div class="content__body">
      <div class="meta">
        <div class="meta__item">
          <i class="pi pi-clock"></i>
          <p>{{ data.time }}</p>
        </div>
        <div
          *ngIf="isTypeStops(data) && data.duration !== '0'"
          class="meta__item"
        >
          <i class="pi pi-clock"></i>
          <p>{{ data.duration }}</p>
        </div>
        <div *ngIf="isTypeFrame(data)" class="meta__item">
          <i>
            <svg width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#speed"></use>
            </svg>
          </i>
          <p>{{ data.duration }}</p>
        </div>
      </div>
      <p class="reference" *ngIf="data.contentMessage">
        {{ data.contentMessage }}
      </p>
    </div>
  </div>
</div>
